/**
 *
 * ButtonContainer
 *
 */

import React from 'react';

import { ButtonProps } from '../ButtonProps';

import Button from 'components/Buttons/Button';

import buttonStyles from './styles/buttonStyles';


function ButtonContainer(props:ButtonProps){

  const {
    thisStyles
  } = props;

  return <Button {...props} buttonName={'ButtonContainer'} thisStyles={buttonStyles(thisStyles)}  />;
}


export default ButtonContainer;
